import Component from 'vue-class-component';
import ProductListElementAbstract from '@/components/ProductAbstract/ProductListElementAbstract';
import ProductPhotosDownload from '@/components/ProductPhotosDownload/ProductPhotosDownload';

@Component({
    components: {
        ProductPhotosDownload,
    },
})
export default class ProductTableElement extends ProductListElementAbstract {
}